// @flow

// Vendors
import React from 'react';
import classnames from 'classnames';

// Components
import {
  InputCheckbox,
  InputPhone,
  InputRadio,
  InputSelect,
  InputText,
  InputTextarea,
  InputToggle,
  InputZipCode
} from './Inputs';

// types
import { FormFieldType } from '../../types';

const FormField = ({
  id,
  name,
  type = 'text',
  error,
  className,
  helpText,
  ...props
}: FormFieldType) => {
  const hasError = !!error;
  let InputComponent = InputText;

  const inputComponents = {
    text: InputText,
    checkbox: InputCheckbox,
    radio: InputRadio,
    select: InputSelect,
    textarea: InputTextarea,
    toggle: InputToggle,
    phone: InputPhone,
    zipCode: InputZipCode
  };

  if (inputComponents[type]) InputComponent = inputComponents[type];

  return (
    <div
      className={classnames('form__field', className, {
        'form__field--error': !!error,
        'form__field--disabled': !!props.disabled
      })}
    >
      <InputComponent type={type} id={id || name} name={name} {...props} />
      {hasError && <small className="form__help">{error}</small>}
      {helpText && <small className="form__help">{helpText}</small>}
    </div>
  );
};

export default FormField;
